/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoyaltySetupDto { 
    loyaltyProgramId?: number;
    loyaltyProgramStatus?: LoyaltySetupDto.LoyaltyProgramStatusEnum;
    setupSuccessful?: boolean;
    successfullyExtracted?: Array<LoyaltySetupDto.SuccessfullyExtractedEnum>;
    notExtracted?: Array<LoyaltySetupDto.NotExtractedEnum>;
}
export namespace LoyaltySetupDto {
    export type LoyaltyProgramStatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const LoyaltyProgramStatusEnum = {
        Invalid: 'INVALID' as LoyaltyProgramStatusEnum,
        InProgress: 'IN_PROGRESS' as LoyaltyProgramStatusEnum,
        Valid: 'VALID' as LoyaltyProgramStatusEnum
    };
    export type SuccessfullyExtractedEnum = 'COMPANY_NO' | 'INVOICE_DATE' | 'INVOICE_TIME' | 'INVOICE_NO' | 'PRICE' | 'JIR';
    export const SuccessfullyExtractedEnum = {
        CompanyNo: 'COMPANY_NO' as SuccessfullyExtractedEnum,
        InvoiceDate: 'INVOICE_DATE' as SuccessfullyExtractedEnum,
        InvoiceTime: 'INVOICE_TIME' as SuccessfullyExtractedEnum,
        InvoiceNo: 'INVOICE_NO' as SuccessfullyExtractedEnum,
        Price: 'PRICE' as SuccessfullyExtractedEnum,
        Jir: 'JIR' as SuccessfullyExtractedEnum
    };
    export type NotExtractedEnum = 'COMPANY_NO' | 'INVOICE_DATE' | 'INVOICE_TIME' | 'INVOICE_NO' | 'PRICE' | 'JIR';
    export const NotExtractedEnum = {
        CompanyNo: 'COMPANY_NO' as NotExtractedEnum,
        InvoiceDate: 'INVOICE_DATE' as NotExtractedEnum,
        InvoiceTime: 'INVOICE_TIME' as NotExtractedEnum,
        InvoiceNo: 'INVOICE_NO' as NotExtractedEnum,
        Price: 'PRICE' as NotExtractedEnum,
        Jir: 'JIR' as NotExtractedEnum
    };
}


